import React, { useState, useEffect } from 'react'
import Cookies from 'universal-cookie';
import {initializeAndTrackGoogleTagManager} from 'gatsby-plugin-gdpr-cookies/services'
// import {initializeAndTrackGoogleAnalytics} from 'gatsby-plugin-gdpr-cookies/services'

function isBrowser() {
    return typeof window !== 'undefined';
}

function getValue(key, defaultValue) {
    return isBrowser() && window.localStorage.getItem(key)
        ? JSON.parse(window.localStorage.getItem(key))
        : defaultValue;
}

function setValue(key, value) {
    window.localStorage.setItem(key, JSON.stringify(value));
}

function useStickyState(defaultValue, key) {
    const [value, setter] = useState(() => {
        return getValue(key, defaultValue);
    });

    useEffect(() => {
        setValue(key, value);
    }, [key, value]);

    return [value, setter];
}

export const CookieModal = () => {
    const [bannerHidden, setBannerHidden] = useStickyState(
        false,
        'consentCookieHidden',
    );
    const [state, setState] = useState({
        acceptAnalytical: false
    });
    const handleAnalytical = (e) => {
        setState({...state, acceptAnalytical: !state.acceptAnalytical});
    }

    const handleAccept = (e, action) => {
        let cookiePrefs = (action === 'all' ? true : state.acceptAnalytical);
        const cookies = new Cookies();
        cookies.set('gdpr-google-analytics', cookiePrefs, { path: '/', sameSite: 'Strict', maxAge: 60 * 60 * 24 * 365 });
        setBannerHidden(true);
        if (window.gatsbyPluginGDPRCookiesOptions && cookiePrefs) {
            initializeAndTrackGoogleTagManager(window.gatsbyPluginGDPRCookiesOptions.googleTagManager);
        }
    }

    return (
        <>
            {(isBrowser() && !bannerHidden) && (
        <div className="c-modal__cookie-overlay" id="cookies">
            <div className="c-modal c-modal__cookies -bottom-drawer@tablet  -medium ">
                <div className="c-modal__split-body">
                    <div className="c-modal__split-body -left">
                        <h1>Cookies op vdab.be</h1>
                        <p>VDAB gebruikt cookies om je surfervaring gemakkelijker en aangenamer te
                            maken en de inhoud van de site beter af te stemmen op je behoeften en voorkeuren. Sommige cookies zijn
                            noodzakelijk om de website goed te laten werken. Deze kan je niet weigeren. De andere cookies kies je
                            zelf. <a href="/cookies">Meer info lees je in ons cookiebeleid</a>.</p>
                        <div className="form-container -bg-transparent">
                            <ul id="eu-cookie-compliance-categories" className="u-reset-list form-row">
                                <li className="c-modal__cookielist">
                                    <label htmlFor="cookie-category-essentieel" className="checkbox c-modal__cookielabel">
                                        <input type="checkbox" name="cookie-categories" id="cookie-category-essentieel"
                                               value="essentieel" defaultChecked={true} disabled />
                                        Noodzakelijke cookies
                                    </label>
                                    <span className="u-ml15 u-text-meta" id="func">Deze cookies zijn nodig voor je gebruiksgemak en om je websitebezoek veilig en goed te laten verlopen. Je kan ze niet weigeren.</span>
                                </li>
                                <li className="c-modal__cookielist">
                                    <label htmlFor="cookie-category-analytisch" className="checkbox c-modal__cookielabel">
                                        <input type="checkbox" name="cookie-categories" id="cookie-category-analytisch" value="analytisch" checked={state.acceptAnalytical} onChange={handleAnalytical} /> Analytische cookies
                                    </label>
                                    <span className="u-ml15 u-text-meta" id="func">We gebruiken deze cookies om het bezoek aan onze website te analyseren en verbeteren (Google). Wij verwerken je gegevens anoniem in rapporten en statistieken.</span>
                                </li>
                            </ul>
                            <div>
                                <div className="c-divider"></div>
                                <div className="o-btn-group">
                                    <button onClick={(e) => handleAccept(e, 'all')} className="c-btn -primary -medium agree-button eu-cookie-compliance-default-button">Alle cookies aanvaarden</button>
                                    <button onClick={(e) => handleAccept(e, 'save')} className="c-btn -primary -medium eu-cookie-compliance-save-preferences-button">Bewaar mijn keuze</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="c-modal__split-body -right">
                        <div className="c-modal__image-box">
                            <img src="https://cdn.vdab.be/img/cookies.svg" className="c-modal__image" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>   )}
        </>
    );
}